module.exports = __webpack_public_path__ + "img/cube1.09da34f5.png";